<template>
  <div
    tabindex="0"
    class="icon-cont"
    @click="changePaneState"
    @keyup="changePaneState"
  >
    <rare-collapse-icon v-if="paneOpen" />
    <rare-expand-icon v-if="!paneOpen" />
  </div>
</template>

<script>

import RareCollapsePaneIcon from '../icons/RareCollapsePaneIcon.vue';
import RareExpandPaneIcon from '../icons/RareExpandPaneIcon.vue';

export default {
  name: 'RareExpandCollapseButton',
  components: {
    'rare-collapse-icon': RareCollapsePaneIcon,
    'rare-expand-icon': RareExpandPaneIcon,
  },
  data() {
    return {
      paneOpen: false,
    };
  },
  methods: {
    changePaneState() {
      this.paneOpen = !this.paneOpen;
      this.$emit('changePaneState');
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .icon-cont {
    display: inline-block;
    background-color: #ffffff;
    padding-left: 10px;
    margin-top: 4px;
  }

</style>
